<app-header [logged]="false"  ></app-header>




<div class="container mt-5" >
    <div class="row" >
        <div class="col-6" >
            <img class="img-fluid" src="assets/blog_home.png" >

        </div>
        <div class="col-6" >
            <h2>Blog App</h2>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. 
                Iusto eligendi magni perferendis, nam molestias laboriosam delectus 
                debitis ad quos aperiam dignissimos officiis ut iure totam voluptates qui impedit praesentium incidunt.</p>
                <button style="background-color: orange; color: white;" routerLink='/register' mat-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
                    <mat-icon>
                      how_to_reg
                    </mat-icon>
                    join with us
                  </button>
        </div>
    </div>
</div>
<div style="margin-top: 150px;"  >
    <app-footer ></app-footer>
</div>
